enum TiposMovimentacao {
    Entrada = 1,
    Saida = 2
}

export default TiposMovimentacao;